module.exports = __webpack_public_path__ + "img/idCardBottomSideFile.42f720fc.jpg";